import BaseServices from "../base/BaseServices";

const getFileCustomerSign = async (data) => {
    const result = await BaseServices.request(
        `get-file-customer-sign`,
        data,
        "POST"
    );
    return result;
};
const denySignRevoke = async (data) => {
    const result = await BaseServices.request(
        `deny-sign-revoke`,
        data,
        "POST"
    );
    return result;
};

const getCertificate = async (data) => {
    const result = await BaseServices.request(
        `get-certificate-sign`,
        data,
        "POST"
    );
    return result;
};

const updateFileRevokeSigned = async (data) => {
    const result = await BaseServices.request(
        `update-signed-revoke`,
        data,
        "POST"
    );
    return result;
};
const getTimeServer = async () => {
    const result = await BaseServices.request(
        `get-time-server-sign`,
        {},
        "GET"
    );
    return result;
};

export const SignRevokeDestroyPauseServices = {
    getFileCustomerSign,
    denySignRevoke,
    getCertificate,
    updateFileRevokeSigned,
    getTimeServer
};
